import { gql } from '@apollo/client';
import { FIND_CACHE_FRAGMENT } from './getMyFindsQuery';

export const CREATE_FIND_MUTATION = gql`
  mutation CreateFindMutation($find: FindInput!) {
    createFind(find: $find) {
      ... on CreateFindSuccess {
        find {
          ...FindCacheFields
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${FIND_CACHE_FRAGMENT}
`;
